import h from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import v from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
import F from "../../../@babel/runtime/helpers/esm/createClass2.mjs";
import j from "../../../@babel/runtime/helpers/esm/classCallCheck2.mjs";
import g from "../../../@babel/runtime/helpers/esm/assertThisInitialized2.mjs";
import V from "../../../@babel/runtime/helpers/esm/inherits2.mjs";
import _ from "../../../@babel/runtime/helpers/esm/createSuper2.mjs";
import $ from "../../../@babel/runtime/helpers/esm/wrapNativeSuper.mjs";
import w from "../../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import N from "../../../@babel/runtime/helpers/esm/toConsumableArray2.mjs";
var k = /%[sdj%]/g, P = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (P = function(r, e) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && e.every(function(t) {
    return typeof t == "string";
  }) && console.warn(r, e);
});
function E(r) {
  if (!r || !r.length)
    return null;
  var e = {};
  return r.forEach(function(t) {
    var n = t.field;
    e[n] = e[n] || [], e[n].push(t);
  }), e;
}
function Y(r) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    t[n - 1] = arguments[n];
  var o = 0, i = t.length;
  if (typeof r == "function")
    return r.apply(null, t);
  if (typeof r == "string") {
    var u = r.replace(k, function(f) {
      if (f === "%%")
        return "%";
      if (o >= i)
        return f;
      switch (f) {
        case "%s":
          return String(t[o++]);
        case "%d":
          return Number(t[o++]);
        case "%j":
          try {
            return JSON.stringify(t[o++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return f;
      }
    });
    return u;
  }
  return r;
}
function x(r) {
  return r === "string" || r === "url" || r === "hex" || r === "email" || r === "date" || r === "pattern";
}
function Z(r, e) {
  return !!(r == null || e === "array" && Array.isArray(r) && !r.length || x(e) && typeof r == "string" && !r);
}
function D(r, e, t) {
  var n = [], o = 0, i = r.length;
  function u(f) {
    n.push.apply(n, N(f || [])), o++, o === i && t(n);
  }
  r.forEach(function(f) {
    e(f, u);
  });
}
function O(r, e, t) {
  var n = 0, o = r.length;
  function i(u) {
    if (u && u.length) {
      t(u);
      return;
    }
    var f = n;
    n = n + 1, f < o ? e(r[f], i) : t([]);
  }
  i([]);
}
function I(r) {
  var e = [];
  return Object.keys(r).forEach(function(t) {
    e.push.apply(e, N(r[t] || []));
  }), e;
}
var A = /* @__PURE__ */ function(r) {
  V(t, r);
  var e = _(t);
  function t(n, o) {
    var i;
    return j(this, t), i = e.call(this, "Async Validation Error"), w(g(i), "errors", void 0), w(g(i), "fields", void 0), i.errors = n, i.fields = o, i;
  }
  return F(t);
}(/* @__PURE__ */ $(Error));
function q(r, e, t, n, o) {
  if (e.first) {
    var i = new Promise(function(a, d) {
      var p = function(l) {
        return n(l), l.length ? d(new A(l, E(l))) : a(o);
      }, s = I(r);
      O(s, t, p);
    });
    return i.catch(function(a) {
      return a;
    }), i;
  }
  var u = e.firstFields === !0 ? Object.keys(r) : e.firstFields || [], f = Object.keys(r), b = f.length, m = 0, c = [], y = new Promise(function(a, d) {
    var p = function(s) {
      if (c.push.apply(c, s), m++, m === b)
        return n(c), c.length ? d(new A(c, E(c))) : a(o);
    };
    f.length || (n(c), a(o)), f.forEach(function(s) {
      var l = r[s];
      u.indexOf(s) !== -1 ? O(l, t, p) : D(l, t, p);
    });
  });
  return y.catch(function(a) {
    return a;
  }), y;
}
function R(r) {
  return !!(r && r.message !== void 0);
}
function S(r, e) {
  for (var t = r, n = 0; n < e.length; n++) {
    if (t == null)
      return t;
    t = t[e[n]];
  }
  return t;
}
function z(r, e) {
  return function(t) {
    var n;
    return r.fullFields ? n = S(e, r.fullFields) : n = e[t.field || r.fullField], R(t) ? (t.field = t.field || r.fullField, t.fieldValue = n, t) : {
      message: typeof t == "function" ? t() : t,
      fieldValue: n,
      field: t.field || r.fullField
    };
  };
}
function B(r, e) {
  if (e) {
    for (var t in e)
      if (e.hasOwnProperty(t)) {
        var n = e[t];
        v(n) === "object" && v(r[t]) === "object" ? r[t] = h(h({}, r[t]), n) : r[t] = n;
      }
  }
  return r;
}
export {
  A as AsyncValidationError,
  q as asyncMap,
  z as complementError,
  E as convertFieldsError,
  B as deepMerge,
  Y as format,
  Z as isEmptyValue,
  P as warning
};
//# sourceMappingURL=util.mjs.map
